export enum LangEnum {
  ZH = 'ZH',
  EN = 'EN'
}